import { utils } from '@sfaas/util';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getLoginHistoryList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		queryStr = utils.$sf_objectToQueryString({
			plantCd: searchParams.plantCd,
			searchLoginStrDt: searchParams.searchLoginStrDt,
			searchLoginEndDt: searchParams.searchLoginEndDt,
			searchUserId: searchParams.searchUserId,
			searchUserNm: searchParams.searchUserNm,
			//
			currentPage,
			pageUnit
		});
		// BASE_URL : sfcc-fe
		let url = `${BASE_URL}/user/v1/plants/${searchParams.plantCd}/loginHistory` + queryStr;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
